import { CoreApi } from 'service/axios-api';
import { rootStore } from 'store/root';
import { sleep } from './utils';

const { nxlApi, dataLayer } = window;

export const checkEula = async (productId: string) => {
    // V4 TW - 50207; V4 GB - 59739; Vidictus TW - 50220 (FE-1553)
    if (['50207', '59739', '50220'].includes(productId)) {
        return coreEulaCheck(productId);
    }
    const game = rootStore.appStore.pc.find((x) => x.productId === productId) || { useEULA: false };

    if (!game.useEULA) return true;

    const localEulaData = JSON.parse(localStorage.getItem('eula') || '{}');
    const accountId = sessionStorage.getItem('hashedUserNo') ?? 'local';
    if (localEulaData[productId] && localEulaData[productId][accountId] && localEulaData[productId][accountId].version === game.eulaVersion)
        return true;

    const plexLog = {
        component: 'stats',
        data: {
            event_name: 'eula_contents',
            type: 'viewed',
            version: game.eulaVersion,
            productId,
        },
    };
    nxlApi.plex.send(plexLog);
    const result = await rootStore.dialogs.open('Eula', {
        contents: game.eulaContents.value,
    });
    if (result) {
        // accepted
        plexLog.data.type = 'accepted';
        nxlApi.plex.send(plexLog);
        const newEulaData: any = {};
        newEulaData[accountId] = {
            version: game.eulaVersion,
        };
        localEulaData[productId] = newEulaData;
        localStorage.setItem('eula', JSON.stringify(localEulaData));
    } else {
        // declined
        plexLog.data.type = 'declined';
        nxlApi.plex.send(plexLog);
    }
    return result;
};

const coreEulaCheck = async (productId: string) => {
    const gameInfo = rootStore.appStore.pc.find((x) => x.productId === productId);
    const { data } = await CoreApi.get('/game-user/v2/terms', { params: { productId, language: rootStore.systemInfo.lang } });

    if (!data.terms || data.terms.length === 0) {
        return true;
    }

    const termsLen = data.terms.length;
    const acceptedTerms: { termId: number; agreed: number }[] = [];
    const showEula = async (index = 0): Promise<boolean> => {
        if (index >= termsLen) {
            CoreApi.post('/game-user/v2/terms', { productId, terms: acceptedTerms }).then(
                () => {
                    dataLayer.push({
                        event: 'gameSpecificEULA - Result',
                        'EULA game name': gameInfo?.name,
                        'EULA game ID': productId,
                        'EULA Result': 'Accepted',
                    });
                },
                (error) => {
                    console.log(error);
                }
            );
            return true;
        }
        const term = data.terms[index];
        dataLayer.push({
            event: 'gameSpecificEULA - Viewed',
            'EULA game name': gameInfo?.name,
            'EULA game ID': productId,
            'EULA ID': term.itemId,
        });
        const result = await rootStore.dialogs.open('Eula', { src: term.link });
        await sleep(500);
        if (result) {
            acceptedTerms.push({
                termId: term.itemId,
                agreed: 1,
            });
            return showEula(index + 1);
        }
        dataLayer.push({
            event: 'gameSpecificEULA - Result',
            'EULA game name': gameInfo?.name,
            'EULA game ID': productId,
            'EULA Result': 'Declined',
        });
        return false;
    };

    return showEula();
};
